import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import parser from 'html-react-parser';

const TermsConditionsContent = () => {
  const { t } = useLanguage();

  // Map section IDs to translation keys
  const sections = [
    { id: 'scope', key: 'terms.sections.scope' },
    { id: 'subject', key: 'terms.sections.subject' },
    { id: 'no-contract', key: 'terms.sections.noContract' },
    { id: 'platform-use', key: 'terms.sections.platformUse' },
    { id: 'user-obligations', key: 'terms.sections.userObligations' },
    { id: 'liability', key: 'terms.sections.liability' },
    { id: 'availability', key: 'terms.sections.availability' },
    { id: 'termination', key: 'terms.sections.termination' },
    { id: 'data-protection', key: 'terms.sections.dataProtection' },
    { id: 'final-provisions', key: 'terms.sections.finalProvisions' },
  ];

  return (
    <div className="st-terms-content">
      <h1 className="st-terms-title">{t('terms.meta.title')}</h1>
      <p className="st-terms-updated">
        <strong>{t('terms.lastUpdatedLabel')}:</strong> {t('terms.lastUpdated')}
      </p>

      {sections.map((section) => (
        <section key={section.id} id={section.id} className="st-terms-section">
          <h2 className="st-terms-section-title">
            {t(`${section.key}.title`)}
          </h2>
          <div className="st-terms-section-content">
            {parser(t(`${section.key}.content`))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default TermsConditionsContent;
